import(/* webpackMode: "eager", webpackExports: ["SkoolSearch"] */ "/workspace/dotheforgejo/oxpa-pro/src/app/(portal)/tools/uchebnye-centry/skool-search.tsx");
